<template lang="pug">
Layout(include-layout-class="true")
   .TeamCreateContainer._relative
      Loading(v-if="busy || loading" radius)
      div(v-if="!loading")
         ._t-center._mb2 
            ._fs-4._mb05 Step 1: Company
            ._c-grey-500._fs-075 (Can be changed later)
         ._mb2
            form(@submit.prevent="handleSubmit")
               //- Company: Select existing
               ._mb075(v-if="selectFromExistingCompany")
                  ._mb1
                     .LabelError(v-if="showErrors && !$v.nameCompany.selectedOrEnteredCompany") A company is required
                     label.InputLabel-value Select company
                     vSelect._fs-3(v-model="existingCompanyRef" placeholder="Select company" :options="makerState.companies" :getOptionLabel="option => option.data.name" :clearable="false" :searchable="false" :reduce="company => company.ref" maxHeight="268px")
                        template(slot="option" slot-scope="option")
                           ._fs-1 {{option.data.name}}
                  button.Btn.Btn--xs.Btn--white(type="button" @click="toggleExistingOrNew()") Add new company
               //- Company: Create new
               ._mb075(v-if="!hasExistingCompany || !selectFromExistingCompany")
                  ._mb1
                     label.InputLabel-value._c-grey-700._w100._pb0
                        .LabelText._mb025 Company name
                        ._c-grey-400._fs-05._mb05 example: Acme
                        .LabelError(v-if="showErrors && !$v.nameCompany.selectedOrEnteredCompany") A company name is required
                        .LabelError(v-if="showErrors && $v.nameCompany.selectedOrEnteredCompany && !nameIsUnique") That name is not available
                        input.Input(tabindex="1" type="text" v-model.trim="nameCompany" placeholder="" @keydown="handleNameCompanyInputChange")
                  button.Btn.Btn--xs.Btn--white(type="button" @click="toggleExistingOrNew()" v-if="hasExistingCompany") Select existing company
               ._mt2
                  AddTeamNextBtn()
         ._fs-075
            | Company already added? 
            router-link(to="/add-team/details/") Request to join
</template>

<style lang="sass" scoped>
.TeamCreateContainer
   max-width: 350px
   width: 100%
   +mx(auto)
   background-color: white
   border-radius: $radius
   +boxShadow--2
   +px($s-1)
   padding-top: $s-1-5
   padding-bottom: $s-1
   +above(375px)
      +px($s-1-5)
      padding-bottom: $s-1-5
</style>

<script>
import AddTeamNextBtn from '~/components/AddTeamNextBtn.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import slugify from '@sindresorhus/slugify'
import * as faunaQueries from '~/faunaQueries.js'
import { required } from 'vuelidate/lib/validators'
import vSelect from 'vue-select'

export default {
   components: {
      AddTeamNextBtn,
      vSelect,
   },
   metaInfo: {
      title: `Step 1: Company`,
      link: [{ rel: 'stylesheet', href: 'https://unpkg.com/vue-select@latest/dist/vue-select.css' }],
   },
   data() {
      return {
         loading: true,
         busy: false,
         showErrors: false,
         nameCompany: null,
         existingCompanyRef: null,
         slugForUrl: null,
         ip: this.$store.state.userIP,
         hasExistingCompany: false,
         selectFromExistingCompany: false,
         nameIsUnique: true,
      }
   },
   validations: {
      existingCompanyRef: {
         selectedOrEnteredCompany(value) {
            if (value || this.nameCompany !== '') {
               return true
            } else {
               return false
            }
         },
      },
      nameCompany: {
         selectedOrEnteredCompany(value) {
            if (value || this.existingCompanyRef) {
               return true
            } else {
               return false
            }
         },
      },
   },
   computed: {
      ...mapState(['addTeamTempState', 'makerState']),
   },
   methods: {
      toggleExistingOrNew() {
         this.selectFromExistingCompany = !this.selectFromExistingCompany
         this.nameCompany = null
         this.existingCompanyRef = null
      },
      handleNameCompanyInputChange() {
         this.showErrors = false
      },
      handleSubmit() {
         this.busy = true
         if (this.$v.$invalid) {
            this.busy = false
            this.showErrors = true
            return
         }

         const updatedNewTeamTempState = {
            company: {
               ref: this.selectFromExistingCompany ? this.existingCompanyRef : null,
               name: this.selectFromExistingCompany ? null : this.nameCompany,
               slug: this.selectFromExistingCompany ? null : slugify(this.nameCompany),
            },
         }

         return this.$store
            .dispatch('updateNewTeamTempState', updatedNewTeamTempState)
            .then(() => {
               return this.$router.push('/add-team/step-2')
            })
            .catch(() => {
               this.errors.general = true
               this.busy = false
            })
         // })
      },
   },
   mounted() {
      if (!this.addTeamTempState) return
      console.log('this.addTeamTempState: ', this.addTeamTempState.company)

      //- Note: This is here and used to prevent things from breaking due to SSR.
      this.nameCompany = this.addTeamTempState.company && this.addTeamTempState.company.name

      if (this.makerState.companies && this.makerState.companies.length > 0) {
         this.hasExistingCompany = true
         this.selectFromExistingCompany = this.addTeamTempState && this.addTeamTempState.company && this.addTeamTempState.company.ref
      }

      this.loading = false
   },
}
</script>
